let _open: (() => void) | null = null;

export const mobileMenuStore = {
  register(fn: () => void) { _open = fn; },
  open() { _open?.(); },
};
